// 越南语 (Vietnamese)
export default {
    public: {
        call: 'Xin chào!',
        logout: 'Đăng xuất',
        delSuccess: 'Xóa thành công',
        switching: 'Chuyển đổi ngôn ngữ thành công',
        login: 'Đăng nhập/Đăng ký',
    },
    ykpHeader: {
        product: 'Sản phẩm',
        productList: 'Danh sách sản phẩm',
        // 左侧产品相关
        allProducts: 'Tất cả sản phẩm',
        searchLiterature: 'Tìm tài liệu',
        readLiterature: 'Đọc tài liệu',
        writeLiterature: 'Viết tài liệu',
        translateLiterature: 'Dịch tài liệu',
        
        // 用户相关
        userProduct: 'Sản phẩm của người dùng',
        personalCenter: 'Trung tâm cá nhân',
        problemFeedback: 'Phản hồi sự cố',
        logout: 'Đăng xuất',
        
        // 问题反馈弹窗
        functionModule: 'Mô-đun chức năng:',
        selectModule: 'Vui lòng chọn mô-đun chức năng gặp sự cố',
        problemDescription: 'Mô tả sự cố:',
        enterDescription: 'Vui lòng nhập mô tả sự cố',
        problemScreenshot: 'Ảnh chụp màn hình:',
        email: 'Email:',
        enterEmail: 'Vui lòng nhập email',
        cancel: 'Hủy',
        submit: 'Gửi',
        feedbackSuccess: 'Gửi phản hồi thành công!',
        
        // 登录相关
        loginType: 'Loại đăng nhập',
        confirm: 'Xác nhận',
        pleaseLogin: 'Vui lòng đăng nhập trước',
        loginExpired: 'Phiên đăng nhập đã hết hạn',
        pleaseUsePersonalAccount: 'Vui lòng sử dụng tài khoản cá nhân để đăng nhập',
        
        // 表单验证
        pleaseSelectModule: 'Vui lòng chọn mô-đun chức năng',
        pleaseEnterDescription: 'Vui lòng nhập mô tả sự cố',
        pleaseEnterEmail: 'Vui lòng nhập email'
    },
}